import { useQuery } from '@tanstack/react-query'
import { skillsApi } from '@/lib/api'

/**
 * Query for fetching all skills used when posting projects
 */
export function useSkills() {
  return useQuery({
    queryKey: ['skills'],
    queryFn: async () => {
      const response = await skillsApi.getAll()
      return response.data.results || response.data
    },
  })
}
